import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

// Font Awesome Icons
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faEnvelope,
  faBars,
  faTimes,
  faBook,
  faUser,
  faChalkboardTeacher,
  faQuestionCircle,
  faCircle,
  faSignOutAlt,
  faEdit,
  faLock,
  faPlus,
  faMinus
} from "@fortawesome/free-solid-svg-icons";
import {
  faTwitter,
  faFacebook,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faUserSecret,
  faTwitter,
  faFacebook,
  faInstagram,
  faEnvelope,
  faBars,
  faTimes,
  faBook,
  faUser,
  faChalkboardTeacher,
  faQuestionCircle,
  faCircle,
  faSignOutAlt,
  faEdit,
  faLock,
  faPlus,
  faMinus
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

//Buefy
import Buefy from "buefy";
//import 'buefy/dist/buefy.css'
Vue.use(Buefy, {
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fas',
});

//scroller
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

// Date Fns
import VueDateFns from "vue-date-fns";
Vue.use(VueDateFns);

//Form Validation
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
